module.exports = __webpack_public_path__ + "media/components/country-flag/static/ie-43783ea15fc8ca42cb825a006d46b150.svg";